import {Component, ElementRef, inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseService} from "../../services/base.service";
import {combineLatest, Subject} from "rxjs";
import {debounceTime, finalize, takeUntil} from "rxjs/operators";
import {AccountGoodsData, Photos} from "../../interfaces/account-goods-data";
import {Clipboard} from "@angular/cdk/clipboard";
import {HeaderComponent} from "../../header/header.component";
import {LocalStorageService} from "../../services/local-storage.service";
import {ActivatedRoute, ParamMap} from "@angular/router";
import {Favorites, FavoritesData} from "../../interfaces/favorites-data";
import {GetBasket} from "../../interfaces/get-basket";
import {HeaderService} from "../../services/header.service";
import {Meta, Title} from "@angular/platform-browser";
import {GoodsService} from "../../services/goods.service";
import {RequestData} from "../../interfaces/request-data";
import {ModalGoodInformationComponent} from "./modal-good-information/modal-good-information.component";
import {Currencies} from "../../interfaces/currencies";
import {AccountData, Brand, Calcdebt, userList, Wars} from "../../interfaces/account-data";
import {MenuService} from "../../services/menu.service";
import {Delivery} from "../../interfaces/delivery";
import {
  ModalGoodAddToBasketMobileComponent
} from "./modal-good-add-to-basket-mobile/modal-good-add-to-basket-mobile.component";
import * as moment from "moment/moment";
import {Store} from "@ngrx/store";
import {setHaveGoodsStore} from "../../store/have-goods/have-goods.actions";
import {setIncludePartnersStore} from "../../store/include-partners/include-partners.action";
import {
  ModalNonReturnableItemsComponent
} from "../account/modal-non-returnable-items/modal-non-returnable-items.component";
import {CategoriesMenuComponent} from "../../shared/categories-menu/categories-menu.component";
import {OrganizationsService} from "../../services/organizations.service";
import {Organization} from "../../interfaces/organization";
import {BuGetBasket, BuGoodsData} from "../../interfaces/bu-goods-data";
import {AssistantActionsService} from "../../services/assistant-actions.service";

@Component({
  selector: 'app-good',
  templateUrl: './good.component.html',
  styleUrls: ['./good.component.scss', '../account/account.component.scss'],
})

export class GoodComponent extends BaseService implements OnInit, OnDestroy {
  @ViewChild('scrollableRef') scrollableRef: ElementRef;
  @ViewChild(HeaderComponent) headerRef: HeaderComponent;
  @ViewChild(ModalGoodInformationComponent) modalGoodInformationComponentRef: ModalGoodInformationComponent;
  @ViewChild(ModalGoodAddToBasketMobileComponent) modalGoodAddToBasketMobileComponentRef: ModalGoodAddToBasketMobileComponent;
  @ViewChild(ModalNonReturnableItemsComponent) modalNonReturnableItemsComponentRef: ModalNonReturnableItemsComponent;
  @ViewChild(CategoriesMenuComponent) categoriesMenuComponentRef: CategoriesMenuComponent;
  @ViewChild('analogsAnchor') analogsAnchorRef?: ElementRef<HTMLElement>;

  private goodsService = inject(GoodsService);
  private headerService = inject(HeaderService);
  private titleService = inject(Title);
  private meta = inject(Meta);
  private http = inject(HttpClient);
  private clipboard = inject(Clipboard);
  private localStorage = inject(LocalStorageService);
  private route = inject(ActivatedRoute);
  private menuService = inject(MenuService);
  private activatedRoute = inject(ActivatedRoute);
  private store: Store<{ haveGoodsStore: boolean; includePartnersStore: boolean }> = inject(Store);
  private organizationsService = inject(OrganizationsService);
  private assistantActions = inject(AssistantActionsService);

  // Картка #965: помічник відкрив картку з якорем analogs - id товару, до чиїх аналогів прокрутити, коли вони прийдуть
  private analogsAnchorFor: string | null = null;
  private assistantUnregister: () => void;

  public isDestroyed: Subject<boolean> = new Subject();
  // Обрывает незавершённые запросы по предыдущему товару/фильтрам при новой загрузке
  private goodsDataReload: Subject<void> = new Subject();
  public activeOrganization: Organization;
  private isOrganizationsLoaded = false;

  public isDarkBackground = false;
  public isAdmin: boolean;
  public roleId: number;
  public goodsData;
  public isArticlesShow = false;
  public isArticleHide = false;
  public currencyName;
  public goodName = '';
  public goodPhotos: Photos[];
  public isOpenModalPhoto = false;
  public isCopyTextShow = false;
  public copyText;
  public basketModalData: {
    index: number,
    name: string,
    pack_id: number,
    warehouse: number,
    count: number,
    gid: string,
    sup_wh_id?: number
  } = {
    index: 0,
    name: '',
    pack_id: 0,
    warehouse: 0,
    count: 1,
    gid: null,
    sup_wh_id: null
  };
  public favoritesModalData: {
    name: string,
    pack_id: any,
    count: number
  } = {
    name: '',
    pack_id: 0,
    count: 1
  };
  public basketData;
  public basketCount: Number;
  public basketSum;
  public favorites: Favorites[] = [];
  public goodId = '0';
  public suppliers;
  public currencies: Currencies[];
  public analogs;
  public analogsGoodsData = [];
  public originalByBrand = [];
  public original = [];
  public group_id: number = 0;
  public isGetData: boolean = false;
  public urlParams = {
    haveGoods: 0,
    includePartners: 0,
  };
  public dataBasket;
  public wars: Wars[];
  public showPartnerWarehouses: boolean;
  public allowLoginUsers: userList[];
  public userListAdmin: userList[];
  public deliveryInfo: Delivery[];
  public deliveryCurrent: Delivery;
  public selectedUser = 'Користувач не вибраний';
  public selectedUserAdmin = 'Користувач не вибраний';
  public currentYear: number;
  public userSupper: number;
  public partnersNotShowReturnMessage: boolean;
  private pendingBasket: { id: number, count: number, sup: any, gid: string };
  // Позиції, які зараз кладемо в кошик (захист від подвійного кліку, #515)
  private addingToBasket: {[key: string]: boolean} = {};
  // Товари, які зараз додаємо в обране: сердечко світиться лише після get_favorites, і подвійний
  // клік слав add_to_favorite двічі - бек додає кількість до наявної, в обраному ставало 2
  private addingToFavorite: {[key: string]: boolean} = {};
  private pendingBasketMobile: { id: number, sup: any, name: string, gid: string };
  public isMobileAgreement = false;
  public categoriesSortedDeep = [];
  public brandsSorted: Brand[] = [];
  public headCategoryName = '';
  public subHeadCategoryName = '';
  public headCategoryNameColored = 'Головна';
  public categoryHeadShow = '';
  public has_cards: boolean;
  public calcDebt: Calcdebt;
  public isFavoriteMessageShow = false;
  private favoriteMessageTimer;
  public favoriteMessage = '';

  constructor() {
    super();

    const title = 'Маслоточка | Список товарів';
    this.currentYear = moment().year();
    this.titleService.setTitle(title);
    this.meta.addTag({name: 'title', content: title});
    this.meta.addTag({name: 'og:title', content: title});
    this.meta.addTag({name: 'twitter:title', content: title});
    this.meta.addTag({name: 'DC.title', content: title});
  }

  ngOnInit() {
    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        if (!organizations || !organizations.length) {
          return;
        }

        this.activeOrganization = organizations.find((org) => org.is_active === '1' || org.is_active === true);

        if (!this.isOrganizationsLoaded) {
          this.isOrganizationsLoaded = true;
          if (this.goodId && this.goodId !== '0') {
            this.getGoodsData();
          }
          this.getBasket();
        }
      });

    // Компонент переиспользуется при переходе между товарами — подписки на store и валюту
    // оформляем один раз здесь, а не в buildData, иначе они копятся с каждым переходом
    this.store.select('haveGoodsStore')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(val => {
        this.urlParams.haveGoods = val ? 1 : 0;
      });

    this.store.select('includePartnersStore')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(val => {
        this.urlParams.includePartners = val ? 1 : 0;
      });

    let currency: string = this.localStorage.get('currencies');

    this.headerService.currency
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((val) => {
        if (currency != val) {
          currency = val;
          this.getGoodsData();
          this.getBasket();
        }
      });

    // Смена товара и фильтров в одной навигации дёргает оба потока в одном тике —
    // debounceTime(0) схлопывает их в одну загрузку, а в buildData всегда уходит актуальный id
    combineLatest([this.route.paramMap, this.activatedRoute.queryParams])
      .pipe(
        debounceTime(0),
        takeUntil(this.isDestroyed),
      )
      .subscribe(([params, routerParams]: [ParamMap, any]) => {
        // з URL приходить рядок: "0" - truthy, і фільтр «В наявності» вважався увімкненим
        if (routerParams.haveGoods) {
          this.urlParams.haveGoods = parseInt(routerParams.haveGoods) === 1 ? 1 : 0;

          this.store.dispatch(setHaveGoodsStore({ value: parseInt(routerParams.haveGoods) === 1}));
        }

        if (routerParams.includePartners) {
          this.urlParams.includePartners = parseInt(routerParams.includePartners) === 1 ? 1 : 0;

          this.store.dispatch(setIncludePartnersStore({ value: parseInt(routerParams.includePartners) === 1}));
        }

        this.buildData(params);
      });

    // Компонент живе й на картці іншого товару: якір - для того товару, на чию картку вів помічник (route /good/<id>)
    this.assistantUnregister = this.assistantActions.register('anchor', (action) => {
      if (action.anchor !== 'analogs' || typeof action.route !== 'string') {
        return;
      }

      this.analogsAnchorFor = action.route.split('/')[2] || null;
      this.scrollToAnalogs();
    });
  }

  /**
   * Прокрутка до блоку аналогів за якорем помічника - коли на картці вже дані саме того товару. Аналогів немає -
   * лишаємось нагорі картки.
   */
  private scrollToAnalogs() {
    if (!this.analogsAnchorFor || this.analogsAnchorFor !== String(this.goodId) || this.goodsData === undefined) {
      return;
    }

    this.analogsAnchorFor = null;

    setTimeout(() => this.analogsAnchorRef?.nativeElement.scrollIntoView({behavior: 'smooth', block: 'start'}));
  }

  buildData(params: ParamMap) {
    this.goodId = params.get('id');

    this.getData();
    this.getFavorites();
    this.getGoodsData();
  }

  getData() {
    this.isGetData = false;

    this.http.post(this.apiRoot + 'accounts/data', {
      currency: this.localStorage.get('currencies'),
      delivery_id: this.localStorage.get('delivery_id'),
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: AccountData) => {
        this.userSupper = data.data.user_supper;

        if (data.data.delivery_info) {
          this.wars = data.data.wars;
          this.isAdmin = data.data.is_admin;
          this.showPartnerWarehouses = data.data.show_partner_warehouses;
          this.allowLoginUsers = data.data.allow_login_users;
          this.roleId = data.data.role_id;
          this.has_cards = data.data.has_cards;

          const menuData = this.menuService.buildDataMenu(data, this.urlParams);

          this.userListAdmin = menuData.userListAdmin;
          this.deliveryInfo = menuData.deliveryInfo;
          this.deliveryCurrent = menuData.deliveryCurrent;
          this.selectedUser = menuData.selectedUser;
          this.selectedUserAdmin = menuData.selectedUserAdmin;
          this.categoriesSortedDeep = menuData.categoriesSortedDeep;
          this.headCategoryName = menuData.headCategoryName;
          this.subHeadCategoryName = menuData.subHeadCategoryName;
          this.categoryHeadShow = menuData.categoryHeadShow;
          this.brandsSorted = menuData.brandsSorted;
          this.calcDebt = menuData.calcDebt;
        }

        this.isGetData = true;

        this.buildFavoritesBasket();
      });
  }

  getGoodsData() {
    this.goodsDataReload.next();
    this.goodsData = undefined;

    if (!this.isOrganizationsLoaded) {
      return;
    }

    const isBuOrganization = this.activeOrganization && this.activeOrganization.type !== 'fiz';

    if (isBuOrganization) {
      this.http.post(this.apiRoot + 'bu_goods/get_goods', {
        good_id: this.goodId,
        have_goods: this.urlParams.haveGoods ? '1' : null,
      })
        .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
        .subscribe((data: BuGoodsData) => {
          // на виняток бек відповідає success: false без goods - buildBuData падав на goods.length
          if (!data?.success) {
            this.clearGoodsData();
            return;
          }

          this.analogs = data.analogs;

          this.currencyName = 'UAH';

          this.goodsData = this.goodsService.buildBuData(data, this.urlParams.haveGoods);

          // товару немає у видачі (порожній goods) - goodsData[0] відсутній
          if (this.urlParams.haveGoods && this.goodsData.length) {
            let hasAvailableGood = false;

            for (let sup of this.goodsData[0].goodsSuppliers) {
              // У партнёра count — остаток основного склада; товар есть и когда он лежит на других его складах
              if (sup.count > 0 || (sup.others && sup.others.length)) {
                hasAvailableGood = true;
                break;
              }
            }

            if (!hasAvailableGood) {
              this.goodsData[0].goodsSuppliers[0].hasntGood = true;
              this.goodsData[0].goodsSuppliers[0].showName = true;
            }
          }

          const originalByBrand = [];
          const original = [];
          const analogsGoodsData = [];

          if (Array.isArray(data.analogs) && data.analogs.length > 0) {
            for (let analog of data.analogs) {
              if (data.goods[0]?.brand_id && analog.brand_id === data.goods[0].brand_id) {
                originalByBrand.push(analog);
              } else if (parseInt(analog.is_original, 10) == 1) {
                original.push(analog);
              } else {
                analogsGoodsData.push(analog);
              }
            }
          }

          data.goods = originalByBrand;
          this.originalByBrand = this.hideNotHaveGoodsData(this.goodsService.buildBuData(data, this.urlParams.haveGoods));

          data.goods = original;
          this.original = this.hideNotHaveGoodsData(this.goodsService.buildBuData(data, this.urlParams.haveGoods));

          data.goods = analogsGoodsData;
          this.analogsGoodsData = this.hideNotHaveGoodsData(this.goodsService.buildBuData(data, this.urlParams.haveGoods));

          this.buildFavoritesBasket();

          if (this.scrollableRef?.nativeElement) {
            this.scrollableRef.nativeElement.scrollTop = 0;
          }

          this.scrollToAnalogs();
        });
      return;
    }

    this.http.post(this.apiRoot + 'good/data', {
      good_id: this.goodId,
      delivery_id: this.localStorage.get('delivery_id'),
      haveGoods: this.urlParams.haveGoods,
      include_partners: this.urlParams.includePartners,
    })
      .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
      .subscribe((data: AccountGoodsData) => {
        // товар видалено/приховано: бек віддає success: false, 'Good not found' без currencies -
        // Object.values(undefined) падав, а на сторінці лишався попередній товар
        if (!data?.success) {
          this.clearGoodsData();
          return;
        }

        this.suppliers = data.suppliers;
        this.analogs = data.analogs;
        this.currencies = data.currencies;

        if (data.group_id) {
          this.group_id = Number(data.group_id);
        }

        const currency_id = this.localStorage.get('currencies');
        this.currencyName = Object.values(this.currencies).find(element => element.id == parseInt(currency_id)).name;

        this.goodsData = this.goodsService.buildData(data, this.urlParams.haveGoods);

        // buildData може не додати жодного постачальника (усі пропущені) - тоді позначати «немає» нікому
        if (this.urlParams.haveGoods && this.goodsData[0] && this.goodsData[0].goodsSuppliers.length) {
          let hasAvailableGood = false;

          for (let sup of this.goodsData[0].goodsSuppliers) {
            // У партнёра count — остаток основного склада; товар есть и когда он лежит на других его складах
            if (sup.count > 0 || (sup.others && sup.others.length)) {
              hasAvailableGood = true;
              break;
            }
          }

          if (!hasAvailableGood) {
            this.goodsData[0].goodsSuppliers[0].hasntGood = true;
            this.goodsData[0].goodsSuppliers[0].showName = true;
          }
        }

        const originalByBrand = [];
        const original = [];
        const analogsGoodsData = [];

        //data.goods = data.analogs;
        if (Array.isArray(data.analogs) && data.analogs.length > 0) {
          for (let analogs of data.analogs) {
            if (this.group_id && this.group_id === Number(analogs.group_id)) {
              originalByBrand.push(analogs);
            } else if (parseInt(analogs.is_original, 10) == 1) {
              original.push(analogs);
            } else {
              analogsGoodsData.push(analogs);
            }
          }
        }

        data.goods = originalByBrand;
        this.originalByBrand = this.hideNotHaveGoodsData(this.goodsService.buildData(data, this.urlParams.haveGoods));

        data.goods = original;
        this.original = this.hideNotHaveGoodsData(this.goodsService.buildData(data, this.urlParams.haveGoods));

        data.goods = analogsGoodsData;
        this.analogsGoodsData = this.hideNotHaveGoodsData(this.goodsService.buildData(data, this.urlParams.haveGoods));

        const pack_ids = [];

        pack_ids.push(...this.goodsService.getWaitingPackIds(this.goodsData));
        pack_ids.push(...this.goodsService.getWaitingPackIds(this.originalByBrand));
        pack_ids.push(...this.goodsService.getWaitingPackIds(this.original));
        pack_ids.push(...this.goodsService.getWaitingPackIds(this.analogsGoodsData));

        if (pack_ids.length) {
          this.http.post(this.apiRoot + 'good/get_arrivals_datas', {
            pack_ids,
            delivery_id: this.localStorage.get('delivery_id'),
          })
            .pipe(takeUntil(this.goodsDataReload), takeUntil(this.isDestroyed))
            .subscribe((resp: any) => {
              this.goodsService.applyWaitingExpect(this.goodsData, resp.data);
              this.goodsService.applyWaitingExpect(this.originalByBrand, resp.data);
              this.goodsService.applyWaitingExpect(this.original, resp.data);
              this.goodsService.applyWaitingExpect(this.analogsGoodsData, resp.data);
            });
        }

        this.buildFavoritesBasket();

        if (this.scrollableRef?.nativeElement) {
          this.scrollableRef.nativeElement.scrollTop = 0;
        }

        this.scrollToAnalogs();
      });
  }

  // товар не знайдено - не показуємо дані попереднього товару (компонент перевикористовується)
  clearGoodsData() {
    this.goodsData = [];
    this.originalByBrand = [];
    this.original = [];
    this.analogsGoodsData = [];
  }

  getBasket() {
    if (!this.isOrganizationsLoaded) {
      return;
    }

    const isBuOrganization = this.activeOrganization && this.activeOrganization.type !== 'fiz';

    if (isBuOrganization) {
      this.basketData = undefined;

      this.http.post(this.apiRoot + 'bu_basket/get_basket', {})
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: BuGetBasket) => {
          this.basketData = data.data;

          this.dataBasket = this.menuService.buildBuBasketData(data);

          this.basketSum = this.dataBasket.basketSum.toFixed(2);
          this.basketCount = this.dataBasket.basketCount;
          this.currencyName = this.dataBasket.currencyName;

          this.buildFavoritesBasket();
        });

      return;
    }

    this.basketData = undefined;

    this.http.get(this.apiRoot + 'accounts/get_basket')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: GetBasket) => {
        this.basketData = data.basket_data;
        this.partnersNotShowReturnMessage = data.partners_not_show_return_message;

        const currency_id = this.localStorage.get('currencies');
        this.dataBasket = this.menuService.buildBasketData(data, currency_id);

        this.basketSum = this.dataBasket.basketSum.toFixed(2);
        this.basketCount = this.dataBasket.basketCount;
        this.currencyName = this.dataBasket.currencyName;

        this.buildFavoritesBasket();
      });
  }

  buildCategoriesMenuGoodsData() {
    // this.getGoodsData(); TODO Лишний вызов, нужно проверить
  }

  showModalPayment() {
    this.headerRef.modalPaymentChange();
  }

  brandsMenuShow() {
    this.categoriesMenuComponentRef.brandMenuShow();
  }

  getBasketMobile() {
    this.getBasket();
  }

  getBasketAnalogsEvent() {
    this.getBasket();
  }

  isDarkBackgroundAddGoodToBasketModal() {
    this.isDarkBackground = false;
  }

  getFavorites() {
    this.http.get(this.apiRoot + 'accounts/get_favorites')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: FavoritesData) => {
        if (data && Array.isArray(data.data)) {
          this.favorites = data.data;
        } else {
          this.favorites = [];
        }

        this.buildFavoritesBasket();
      });
  }

  buildAnalogsFavoritesBasket() {
    this.getFavorites();
  }

  buildFavoritesBasket() {
    if (this.goodsData != undefined && this.basketData != undefined) {
      for (let good of this.goodsData) {
        for (let sup of good.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == good.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == good.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == good.id)) : false;
        }
      }

      for (let analog of this.originalByBrand) {
        for (let sup of analog.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == analog.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == analog.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == analog.id)) : false;
        }
      }

      for (let analog of this.original) {
        for (let sup of analog.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == analog.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == analog.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == analog.id)) : false;
        }
      }

      for (let analog of this.analogsGoodsData) {
        for (let sup of analog.goodsSuppliers) {
          sup.price = Number(sup.price).toFixed(2);
          sup.turnOn = this.basketData ? (!!this.basketData.find(element => {
            if (!Number(element.zak_supp_id)) {
              return element.pack_id == analog.id && element.warehouse == sup.war;
            } else {
              return element.zak_supp_id == sup.id && element.pack_id == analog.id && element.warehouse == sup.war;
            }
          })) : false;
          sup.star = Array.isArray(this.favorites) ? (!!this.favorites.find(element => element.pack_id == analog.id)) : false;
        }
      }
    }
  }

  openGoodInfoModal(good_id) {
    this.modalGoodInformationComponentRef.openModalGoodInformation(good_id);
  }

  hideNotHaveGoodsData(data) {
    let result = [];

    if (this.urlParams.haveGoods) {
      for (let analog of data) {
        for (let sup of analog.goodsSuppliers) {
          if (sup.count > 0 || (sup.others && sup.others.length)) {
            result.push(analog);
            break;
          }
        }
      }
    } else {
      result = data;
    }

    return result;
  }

  openModalPhotos(good) {
    this.goodName = good.name
    this.goodPhotos = good.photos

    this.isOpenModalPhoto = true;
    this.isDarkBackground = true;
  }

  articlesShow() {
    this.isArticlesShow = true;
  }

  articleCopy(firstArticle) {
    this.clipboard.copy(firstArticle);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  packIdCopy(packId: string) {
    this.clipboard.copy(packId);

    this.isCopyTextShow = true;

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000)
  }

  articleBulbCopy(lastArticles, event) {
    event.stopPropagation();
    this.clipboard.copy(lastArticles);

    this.isCopyTextShow = true;
    this.isArticleHide = true;

    clearTimeout(this.copyText);
    setTimeout(() => {
      this.isArticleHide = false;
    }, 20);

    clearTimeout(this.copyText);
    this.copyText = setTimeout(() => {
      this.isCopyTextShow = false;
    }, 2000);
  }

  notifyInventoryFinished(package_id) {
    this.http.post(this.apiRoot + 'accounts/subscribe_goods_appeared', {
      package_id
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        alert('Телеграм бот повідомить вас про закінчення інвентаризації цього товару. Якщо ви підписані на бот.');
      });
  }

  showModalWaitDelivery() {
    this.headerRef.openModalWaitingGoods();
  }

  showModalWaitDeliveryEvent() {
    this.showModalWaitDelivery();
  }

  minusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) - 1

    if (sup.countBasket < 1) {
      sup.countBasket = 1;
    }
  }

  plusCount(sup) {
    sup.countBasket = parseInt(sup.countBasket) + 1

    if (isNaN(sup.countBasket)) {
      sup.countBasket = 1;
    }
  }

  addToBasketMobile(id, sup, name) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasketMobile = { id, sup, name, gid };

      this.isMobileAgreement = true;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.basketMobileModalShow(id, sup, name);
    }
  }

  basketMobileModalShow(id, sup, name) {
    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    this.basketModalData.name = name;
    this.basketModalData.pack_id = id;
    this.basketModalData.warehouse = sup.war;
    this.basketModalData.count = 1;
    this.basketModalData.gid = sup.gid || null;
    this.basketModalData.sup_wh_id = sup.sup_wh_id || null;

    this.modalGoodAddToBasketMobileComponentRef.modalShow();

    this.isDarkBackground = true;
  }

  addToBasket(id, count, sup) {
    const gid = sup.gid || null;

    if (sup.partner && !this.partnersNotShowReturnMessage) {

      this.pendingBasket = { id, count, sup, gid };

      this.isMobileAgreement = false;

      this.modalNonReturnableItemsComponentRef.show();
    } else {
      this.sendAddToBasket(id, count, sup, gid);
    }
  }

  sendAddToBasket(id, count, sup, gid) {
    if (sup.partner) {
      id = `z_${sup.id}_${id}`;
    }

    // Подвійний клік «В кошик» клав позицію двічі (#515; у мобільній модалці захист є з #305).
    // Поки запит по цій позиції йде і ще пів секунди від кліку, повтор ігноруємо.
    const addKey = id + '_' + sup.war + '_' + (sup.sup_wh_id || '');

    if (this.addingToBasket[addKey]) {
      return;
    }

    this.addingToBasket[addKey] = true;
    const addStartedAt = Date.now();

    const payload: any = {
      package_id: id,
      count: count,
      warehouse: sup.war,
      delivery: this.localStorage.get('delivery_id'),
      gid: gid
    };

    // Склад партнёра (контракт п.3 с бэком): пока бэк поле не читает — кладёт как раньше, без склада
    if (sup.sup_wh_id) {
      payload.sup_wh_id = sup.sup_wh_id;
    }

    this.http.post(this.apiRoot + 'basket_data/add_basket', payload)
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToBasket[addKey], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe((data: RequestData) => {
        this.goodsService.notifyAddBasketError(data);
        this.getBasket();
      })
  }

  agreeAddToBasket() {
    if (!this.isMobileAgreement && this.pendingBasket) {
      const { id, count, sup, gid } = this.pendingBasket;
      this.sendAddToBasket(id, count, sup, gid);
    } else if (this.isMobileAgreement && this.pendingBasketMobile) {
      const { id, sup, name} = this.pendingBasketMobile;
      this.basketMobileModalShow(id, sup, name);
    }
  }

  agreeNotShowMore() {
    this.http.post(this.apiRoot + 'basket_data/partners_not_show_return_message', {})
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.agreeAddToBasket();
      });
  }


  toggleFavorite(name, id, isFavorite: boolean) {
    if (isFavorite) {
      this.http.post(this.apiRoot + 'favorites/delete', {
        package_id: id
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe(() => {
          this.getFavorites();
          this.showFavoriteMessage('Продукт видалено із списку побажань');
        });

      return;
    }

    if (this.addingToFavorite[id]) {
      return;
    }

    this.addingToFavorite[id] = true;
    const addStartedAt = Date.now();

    this.favoritesModalData.name = name;
    this.favoritesModalData.pack_id = id;

    this.http.post(this.apiRoot + 'favorites/add_to_favorite', {
      package_id: this.favoritesModalData.pack_id,
      count: this.favoritesModalData.count
    })
      .pipe(
        takeUntil(this.isDestroyed),
        finalize(() => {
          setTimeout(() => delete this.addingToFavorite[id], Math.max(0, 500 - (Date.now() - addStartedAt)));
        })
      )
      .subscribe(() => {
        this.favoritesModalData.count = 1;
        this.getFavorites();
        this.showFavoriteMessage('Додано в обране.');
      })
  }

  showFavoriteMessage(message: string) {
    this.favoriteMessage = message;
    this.isFavoriteMessageShow = true;

    clearTimeout(this.favoriteMessageTimer);

    this.favoriteMessageTimer = setTimeout(() => {
      this.isFavoriteMessageShow = false;
    }, 2500);
  }

  buildNavigationMenuGoodsData() {
  }

  closeModal() {
    this.isOpenModalPhoto = false;
    this.isDarkBackground = false;
  }

  ngOnDestroy() {
    this.assistantUnregister();
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
    this.goodsDataReload.complete();
  }
}
